module.exports = __webpack_public_path__ + "scorpio-7bb4603a46fd5c1c60e5.png";